import { Phone, Clock, MapPin } from "lucide-react";
import { LogoMark } from "./Logo";
import { Reveal } from "./Reveal";
import { PHONE_DISPLAY, PHONE_TEL, scrollToSection } from "../constants/content";

export const Footer = () => (
    <footer className="relative bg-white overflow-hidden">
        <div className="h-2 hazard-stripes" />

        <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-24 pb-32 sm:pb-16 text-center">
            <Reveal>
                <p className="font-mono-ind text-xs uppercase tracking-[0.32em] text-[#FF3B30]">
                    One call does it all
                </p>
                <h2 className="mt-5 font-display font-black uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl text-[#141721] leading-[1.02]">
                    Ready to turn your{" "}
                    <span className="text-stroke-amber">junk car</span>
                    <br />
                    into <span className="text-[#FF3B30]">instant cash?</span>
                </h2>
                <a
                    href={PHONE_TEL}
                    data-testid="footer-call-cta"
                    className="animate-pulse-ring mt-12 inline-flex items-center gap-4 rounded-md bg-[#FF3B30] px-10 py-5 font-display font-black text-xl sm:text-2xl text-white uppercase tracking-wide transition-all duration-300 hover:bg-[#E0342B] hover:-translate-y-1"
                >
                    <Phone className="h-6 w-6" strokeWidth={2.8} />
                    {PHONE_DISPLAY}
                </a>

                <div className="mt-12 flex flex-wrap justify-center gap-x-10 gap-y-4 text-sm text-[#565B6B]">
                    <span className="inline-flex items-center gap-2">
                        <Clock className="h-4 w-4 text-[#FF3B30]" />
                        Open 7 days a week · Every day 7AM – 8PM
                    </span>
                    <span className="inline-flex items-center gap-2">
                        <MapPin className="h-4 w-4 text-[#FF3B30]" />
                        Serving Toronto &amp; the Greater Toronto Area
                    </span>
                </div>
            </Reveal>
        </div>

        <div className="border-t border-[#E3E3DE]">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 py-8 flex flex-col sm:flex-row items-center justify-between gap-6">
                <div className="flex items-center gap-3">
                    <LogoMark size={32} />
                    <div className="leading-none text-left">
                        <span className="block font-display font-extrabold text-[#141721] text-sm tracking-tight uppercase">
                            Toronto Scrap
                        </span>
                        <span className="block font-display font-bold text-[#FF3B30] text-[10px] tracking-[0.22em] uppercase">
                            Car Removal
                        </span>
                    </div>
                </div>

                <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2">
                    {[
                        { label: "How It Works", id: "how-it-works" },
                        { label: "Reviews", id: "reviews" },
                        { label: "Areas", id: "areas" },
                        { label: "FAQ", id: "faq" },
                    ].map((item) => (
                        <button
                            key={item.id}
                            data-testid={`footer-nav-${item.id}`}
                            onClick={() => scrollToSection(item.id)}
                            className="text-xs font-semibold text-[#6B7280] hover:text-[#FF3B30] transition-colors duration-300 uppercase tracking-widest"
                        >
                            {item.label}
                        </button>
                    ))}
                </nav>

                <p className="text-xs text-[#6B7280]">
                    © 2026 Toronto Scrap Car Removal. All rights reserved.
                </p>
            </div>
        </div>
    </footer>
);
